import styled, { keyframes } from "styled-components";

export const Container = styled.section`
	@media screen and (min-width: 0px) {
		min-height: calc(100vh - 90px);
		flex: 1 1 auto;
		display: flex;
		flex-direction: column;

		header {
			background-color: var(--primary-color);
			color: var(--white);
			contain: content;
			padding: 0 1em;

			h2 {
				color: var(--white);
				font-size: 0.875em;
				font-weight: bold;
				text-transform: uppercase;
			}

			p {
				color: var(--white);
				font-size: 0.875em;
				font-weight: 600;
			}

			.form {
				display: flex;
				align-items: center;
				margin-bottom: 1em;
				/* column-gap: 1em; */

				.search {
					background-color: var(--white);
					position: relative;
					min-width: 250px;
					max-width: 250px;
					height: 40px;
					overflow: hidden;
					margin-right: 1em;

					input {
						position: absolute;
						top: 0;
						left: 0;
						width: 100%;
						height: 100%;
						border: 0;
						padding-left: 10px;
					}

					img {
						position: absolute;
						top: 50%;
						right: 10px;
						transform: translateY(-50%);
					}
				}

				span {
					color: var(--white);
					font-size: 0.875em;
					font-weight: 600;

					strong {
						color: var(--white);
						font-size: 1rem;
						font-weight: 600;
					}
				}

				a {
					color: var(--white);
					font-size: 1em;
				}
			}

			.btns-group {
				width: 100%;
				display: flex;

				.btn-stores {
					flex: 1 1 auto;
					border: 1px solid #ccc;
					padding: 10px 30px;
					font-size: 1.2em;
					font-weight: 600;
					background-color: var(--white);
					color: var(--dark);
					transition: all 0.3s ease;
					outline: none;

					& + .btn-stores {
						margin-left: 2em;
					}

					&:hover,
					&:focus,
					&:active,
					&:visited,
					&.active {
						background-color: var(--secundary-color);
						color: var(--white);
						border-color: transparent;
						outline: none;
					}
				}
			}
		}

		.content {
			display: flex;
			flex-direction: column;
			div.box {
				flex: 1 1 auto;
				height: calc(100vh - 90px);
			}

			.digitalStores {
				padding: 30px;
				display: grid;
				grid-template-columns: 1fr 1fr;
				column-gap: 30px;
				row-gap: 15px;

				.store {
					position: relative;
					display: flex;
					margin-bottom: 3em;

					&__image {
						width: 80px;
						height: 80px;
						border: 1px solid #ccc;
						padding: 8px;
					}

					.store-content {
						flex: 1 1 auto;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						margin-left: 1em;

						&__title {
							font-size: 1.2em;
							font-weight: bold;
							color: var(--auxiliary-color);
							margin: 0;
						}

						&__link {
							text-decoration: none;
							font-weight: 300;
							color: var(--white);
							text-transform: uppercase;
							background-color: var(--primary-color);
							padding: 10px 30px;
							width: 135px;
							width: max-content;
						}
					}

					&::before {
						position: absolute;
						left: 0;
						right: 0;
						bottom: -1.5em;
						display: inline-block;
						content: "";
						width: 90%;
						max-width: 100%;
						height: 1px;
						background-color: #ccc;
					}
				}
			}
		}
	}

	@media screen and (min-width: 992px) {
		flex-direction: row;

		header {
			flex-basis: 40%;
			padding: 0 2em;

			h2 {
				font-size: 1em;
				margin: 1.5em 0 2em;
			}

			p {
				font-size: 1em;
			}

			.desktop-list {
				p {
					margin: 2em 0;

					strong {
						color: var(--white);
						font-weight: bold;
					}
				}

				.stores-list {
					max-height: 40vh;
					overflow: hidden;
					overflow-y: auto;
					
					padding: 0;
					list-style: none;
					display: flex;
					flex-direction: column;

					li {
						cursor: pointer;
						background-color: transparent;
						transition: all 0.3s ease;
						padding: 5px;
						border-radius: 4px;

						&.active,
						&:hover {
							background-color: rgba(255, 255, 255, 0.1);
						}

						& + li {
							margin-top: 1em;
						}

						address {
							font-style: normal;

							h2,
							p {
								margin: 0;
							}

							h2 {
								font-size: 1.125em;
								font-weight: bold;
							}

							p {
								font-size: 1em;
								font-weight: 500;
							}
						}
					}
				}
			}
		}

		.content {
			height: auto;
			flex-basis: 60%;
			/* background-image: url(${require("@/assets/img/labyes.png")
				.default});
			background-repeat: no-repeat;
			background-position: right bottom; */
		}
	}
`;

export const ContainerMap = styled.div`
	position: relative;
	width: 100%;
	height: 100%;

	&::before {
		content: "";
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.8);
		z-index: 1;
	}

	img {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		z-index: 0;
		object-fit: cover;
		filter: blur(2px) grayscale(100%);
	}

	button {
		position: absolute;
		top: 50%;
		left: 50%;
		transform: translate(-50%);
		z-index: 2;
		background-color: var(--secundary-color);
		color: var(--white);
		border-color: transparent;
		outline: none;
		font-size: 1em;
		padding: 10px 30px;
		text-transform: uppercase;
	}
`;

const change = keyframes`
    0% {
        background-position: -468px 0;
    }
  
    100% {
        background-position: 468px 0; 
    }
`;

export const ShimmerEffect = styled.div`
	width: 100%;
	height: 100%;
	background: #f6f7f8;
	background-image: linear-gradient(
		to right,
		#f6f7f8 0%,
		#edeef1 20%,
		#f6f7f8 40%,
		#f6f7f8 100%
	);
	background-repeat: no-repeat;
	background-size: 800px 100%;
	display: inline-block;
	position: relative;
	animation: ${change} 1s ease-in-out infinite;
`;
